export default {
  "components": {
    "dates": {
      "sun": {
        "default": "Sunday",
        "value": "Sunday"
      },
      "mon": {
        "default": "Monday",
        "value": "Monday"
      },
      "tue": {
        "default": "Tuesday",
        "value": "Tuesday"
      },
      "wed": {
        "default": "Wednesday",
        "value": "Wednesday"
      },
      "thu": {
        "default": "Thursday",
        "value": "Thursday"
      },
      "fri": {
        "default": "Friday",
        "value": "Friday"
      },
      "sat": {
        "default": "Saturday",
        "value": "Saturday"
      },
      "suns": {
        "default": "Sun",
        "value": "Sun"
      },
      "mons": {
        "default": "Mon",
        "value": "Mon"
      },
      "tues": {
        "default": "Tue",
        "value": "Tue"
      },
      "weds": {
        "default": "Wed",
        "value": "Wed"
      },
      "thus": {
        "default": "Thu",
        "value": "Thu"
      },
      "fris": {
        "default": "Fri",
        "value": "Fri"
      },
      "sats": {
        "default": "Sat",
        "value": "Sat"
      },
      "jan": {
        "default": "January",
        "value": "January"
      },
      "feb": {
        "default": "February",
        "value": "February"
      },
      "mar": {
        "default": "March",
        "value": "March"
      },
      "apr": {
        "default": "April",
        "value": "April"
      },
      "may": {
        "default": "May",
        "value": "May"
      },
      "jun": {
        "default": "June",
        "value": "June"
      },
      "jul": {
        "default": "July",
        "value": "July"
      },
      "aug": {
        "default": "August",
        "value": "August"
      },
      "sep": {
        "default": "September",
        "value": "September"
      },
      "oct": {
        "default": "October",
        "value": "October"
      },
      "nov": {
        "default": "November",
        "value": "November"
      },
      "dec": {
        "default": "December",
        "value": "December"
      },
      "jans": {
        "default": "Jan",
        "value": "Jan"
      },
      "febs": {
        "default": "Feb",
        "value": "Feb"
      },
      "mars": {
        "default": "Mar",
        "value": "Mar"
      },
      "aprs": {
        "default": "Apr",
        "value": "Apr"
      },
      "mays": {
        "default": "May",
        "value": "May"
      },
      "juns": {
        "default": "Jun",
        "value": "Jun"
      },
      "juls": {
        "default": "Jul",
        "value": "Jul"
      },
      "augs": {
        "default": "Aug",
        "value": "Aug"
      },
      "seps": {
        "default": "Sep",
        "value": "Sep"
      },
      "octs": {
        "default": "Oct",
        "value": "Oct"
      },
      "novs": {
        "default": "Nov",
        "value": "Nov"
      },
      "decs": {
        "default": "Dec",
        "value": "Dec"
      }
    },    
    "commonPersonalData": {
      "errInvalidFields": {
        "default": "Invalid form fields",
        "value": "Invalid form fields"
      },
      "personalDataSaved": {
        "default": "Your data has been saved.",
        "value": "Your data has been saved."
      }
    },
    "validations": {
      "cannotBeEmpty": {
        "default": "This field cannot be empty.",
        "value": "This field cannot be empty."
      },
      "notAnEmail": {
        "default": "Provided value is not a valid email address.",
        "value": "Provided value is not a valid email address."
      },
      "passwordLength": {
        "default": "The password must be minimum ${charNo} characters with at least one lowercase character and one special character.",
        "value": "The password must be minimum ${charNo} characters with at least one lowercase character and one special character."
      }
    },    
    "bwReceipt": {
      "barOffer": {
        "default": "Offer",
        "value": "Offer"
      },
      "barExtras": {
        "default": "Extras",
        "value": "Extras"
      },
      "barMietbetrag": {
        "default": "Price",
        "value": "Price"
      },
      "recOffer": {
        "default": "Offer",
        "value": "Offer"
      },
      "recServices": {
        "default": "Services",
        "value": "Services"
      },
      "recDiscount": {
        "default": "Discount",
        "value": "Discount"
      },
      "recAccessories": {
        "default": "Extras",
        "value": "Extras"
      },
      "recDeposit": {
        "default": "Kaution",
        "value": "Deposit"
      },
      "bookedFrom": {
        "default": "Booking from",
        "value": "Booking from"
      },
      "bookedTo": {
        "default": "to",
        "value": "to"
      },
      "totalDiscount": {
        "default": "Total Discount",
        "value": "Total Discount"
      },
      "totalSurcharge": {
        "default": "Total Surcharge",
        "value": "Total Surcharge"
      },             
      "vatIncluded": {
        "default": "All prices are including VAT.",
        "value": "All prices are including VAT."
      },       
    },
    "bwStepBar": {
      "bookingDates": {
        "default": "Bookingdates",
        "value": "Bookingdates"
      },
      "services": {
        "default": "Services",
        "value": "Services"
      },
      "accessories": {
        "default": "Extras",
        "value": "Extras"
      },
      "personalData": {
        "default": "Contact data",
        "value": "Contact data"
      },
      "review": {
        "default": "Review",
        "value": "Review"
      },
      "payment": {
        "default": "Payment",
        "value": "Payment"
      }
    },
    "siteHeader": { 
      "passwordRecovery": {
        "default": "Passwort vergessen?",
        "value": "Password forgotten?"
      },      
      "login": {
        "default": "Login",
        "value": "Login"
      },
      "userName": {
        "default": "Username",
        "value": "Username"
      },
      "password": {
        "default": "Password",
        "value": "Password"
      },
      "performLogin": {
        "default": "Login",
        "value": "Login"
      },
      "newRegistration": {
        "default": "Sign up",
        "value": "Sign up"
      },
      "userProfile": {
        "default": "My profile",
        "value": "My profile"
      },
      "userBookings": {
        "default": "My bookings",
        "value": "My bookings"
      },
      "performLogout": {
        "default": "Log out",
        "value": "Log out"
      }
    },
    "siteFooter": {
      "claimText1": {
        "default": "The comprehensive",
        "value": "The comprehensive"        
      },
      "claimText2": {
        "default": "reservation system",
        "value": "reservation system"   
      },  
      "claimText3": {
        "default": "for you",
        "value": "for you"
      }  
    }
  },
  "pages": {
    "bw03Accessories": {
      "back": {
        "default": "Back",
        "value": "Back"
      },
      "accessories": {
        "default": "Extras",
        "value": "Extras"
      },
      "next": {
        "default": "Next",
        "value": "Next"
      }
    },
    "bw07BookingFinished": {
      "confirmation": {
        "default": "Confirmation",
        "value": "Confirmation"
      },
      "bookingFor": {
        "default": "The booking for",
        "value": "The booking for"
      },
      "fromDate": {
        "default": "from",
        "value": "from"
      },
      "toDate": {
        "default": "to",
        "value": "to"
      },
      "forPrice": {
        "default": "for",
        "value": "for"
      },
      "wasFinished": {
        "default": "was successfully completed.",
        "value": "was successfully completed."
      },
      "bookingDetailsSent": {
        "default": "The booking details have been sent to your e-mail address.",
        "value": "The booking details have been sent to your e-mail address."
      },
      "performRegister": {
        "default": "Sign up",
        "value": "Sign up"
      },
      "performPrint": {
        "default": "Print confirmation",
        "value": "Print confirmation"
      },
      "goHome": {
        "default": "Go to homepage ",
        "value": "Go to homepage"
      }
    },
    "bw01OfferDetails": {
      "next": {
        "default": "Next",
        "value": "Next"
      },
      "bookingDates": {
        "default": "Booking data",
        "value": "Booking data"
      },
      "instructionsTitle1": {
        "default": "Instructions",
        "value": "Instructions"
      },
      "instructionsText1": {
        "default": "Adjust the start and end times if necessary. Note that the system can automatically correct your entries to take the posting rules of the provider into account.",
        "value": "Adjust the start and end times if necessary. Note that the system can automatically correct your entries to take the posting rules of the provider into account."
      },      
      "startDate": {
        "default": "Start time",
        "value": "Start time"
      },
      "endDate": {
        "default": "End time",
        "value": "End time"
      },
      "applyNewValues": {
        "default": "Show",
        "value": "Show"
      },
      "weekView": {
        "default": "Week view",
        "value": "Week view"
      },
      "monthView": {
        "default": "Month view",
        "value": "To month view"
      },
      "yourChoice": {
        "default": "Your selection",
        "value": "Your selection"
      },
      "instructionsTitle2": {
        "default": "Instructions",
        "value": "Instructions"
      },
      "yourBooking": {
        "default": "Your reservation",
        "value": "Your reservation"
      },
      "notAvailable": {
        "default": "Not available",
        "value": "Not available"
      },
      "pickupDrop": {
        "default": "Start and end",
        "value": "Start and end"
      },
      "back": {
        "default": "Back",
        "value": "Back"
      }
    },
    "bw06Payment": {
      "payment": {
        "default": "Payment",
        "value": "Payment"
      },
      "bankAccount": {
        "default": "Banking details",
        "value": "Banking details"
      },
      "bankPaymentConditions": {
        "default": "Payment conditions",
        "value": "Payment conditions"
      },
      "back": {
        "default": "Back",
        "value": "Back"
      },
      "firmlyBookFor": {
        "default": "Book bindingly for",
        "value": "Book bindingly for"
      }
    },
    "bw04PersonalData": {
      "street": {
        "default": "Street, Nr. *",
        "value": "Street, Nr. *"
      },      
      "addressAddition": {
        "default": "Address suffix",
        "value": "Addres suffix"
      },
      "postNumber": {
        "default": "ZIP *",
        "value": "ZIP *"
      },
      "place": {
        "default": "Place *",
        "value": "Place *"
      },
      "country": {
        "default": "Country *",
        "value": "Country *"
      },
      "back": {
        "default": "Back",
        "value": "Back"
      },
      "personalData": {
        "default": "Contact details",
        "value": "Contact details"
      },
      "pleaseLogin": {
        "default": "Please log in",
        "value": "Please log in"
      },
      "userName": {
        "default": "User name",
        "value": "User name"
      },
      "password": {
        "default": "Password",
        "value": "Password"
      },
      "loginAsGuest": {
        "default": "Book as guest",
        "value": "Book as guest"
      },
      "login": {
        "default": "Log in",
        "value": "Log in"
      },
      "customerInformation": {
        "default": "Customer information",
        "value": "Customer information"
      },
      "salutation": {
        "default": "Salutation *",
        "value": "Salutation *"
      },
      "firstName": {
        "default": "First name *",
        "value": "First name *"
      },
      "lastName": {
        "default": "Family Name *",
        "value": "Family Name *"
      },
      "organization": {
        "default": "Organization",
        "value": "Organization"
      },         
      "email": {
        "default": "Email *",
        "value": "Email *"
      },
      "phone": {
        "default": "Phone",
        "value": "Phone"
      },
      "mobilePhone": {
        "default": "Cellphone *",
        "value": "Mobile *"
      },        
      "address": {
        "default": "Address",
        "value": "Address"
      },
      "useDifferentBillingAddress": {
        "default": "Use different address for billing.",
        "value": "Use different address for billing."
      },
      "cancelGuestLogin": {
        "default": "Cancel guest booking",
        "value": "Cancel guest booking"
      },
      "next": {
        "default": "Next",
        "value": "Next"
      }
    },
    "bw05Review": {
      "discount": {
        "default": "Disount",
        "value": "Discount"
      },
      "totalDiscount": {
        "default": "Total Discount",
        "value": "Total Discount"
      },  
      "totalSurcharge": {
        "default": "Total Surcharge",
        "value": "Total Surcharge"
      },              
      "offer": {
        "default": "Angebot",
        "value": "Offer"
      },  
      "services": {
        "default": "Dienstleistungen",
        "value": "Services"
      },     
      "accessories": {
        "default": "Extras",
        "value": "Extras"
      },      
      "deposit": {
        "default": "Kaution",
        "value": "Deposit"
      },        
      "review": {
        "default": "Review",
        "value": "Review"
      },
      "mietbetrag": {
        "default": "Price",
        "value": "Price"
      },
      "bookedFrom": {
        "default": "Booking from",
        "value": "Booking from"
      },
      "bookedTo": {
        "default": "to",
        "value": "to"
      },
      "bookingDetails": {
        "default": "Bookingdetails",
        "value": "Bookingdetails"
      },
      "vatIncluded": {
        "default": "Incl. VAT.",
        "value": "incl. VAT"
      },
      "voucher": {
        "default": "Voucher",
        "value": "Voucher"
      }, 
      "addVoucher": {
        "default": "Add Voucher",
        "value": "Add Voucher"
      },            
      "bookAs": {
        "default": "Book as",
        "value": "Book as"
      },
      "bookFirmly": {
        "default": "Book bindingly",
        "value": "Book bindingly"
      },
      "temporaryReservationUntil": {
        "default": "Temporäre Reservation, gültig bis",
        "value": "Temporary Reservation, valid until"
      },      
      "acceptAGB": {
        "default": "I accept the",
        "value": "I accept the ${lessorName}"
      },
      "agb": {
        "default": "General terms and conditions",
        "value": "General terms and conditions"
      },
      "back": {
        "default": "Back",
        "value": "Back"
      },
      "next": {
        "default": "Next",
        "value": "Next"
      },
      "nextTitle": {
        "default": "All mandatory fields need to be filled in and the Terms and Conditions must be accepted.",
        "value": "All mandatory fields need to be filled in and the Terms and Conditions must be accepted."
      }      
    },
    "bw02Services": {
      "next": {
        "default": "Next",
        "value": "Next"
      },
      "services": {
        "default": "Services",
        "value": "Services"
      },
      "back": {
        "default": "Back",
        "value": "Back"
      }
    },
    "objectDetail": {
      "back": {
        "default": "Back",
        "value": "Back"
      },
      "fromPrice": {
        "default": "Starting at",
        "value": "Starting at"
      },
      "bookObject": {
        "default": "Book objects",
        "value": "Book"
      },
      "properties": {
        "default": "Features",
        "value": "Features"
      },
      "notBookableOnline": {
        "default": "This object can't be booked online, please contact the provider for booking this object.",
        "value": "This object can't be booked online, please contact the provider for booking this object."
      },      
      "showMoreProperties": {
        "default": "Show more features",
        "value": "Show more features"
      },
      "showLessProperties": {
        "default": "Close",
        "value": "Close"
      },
      "attachments": {
        "default": "Attachments",
        "value": "Attachments"
      },
      "unnamedAttachment": {
        "default": "Attachment",
        "value": "Attachment"
      },
      "showMoreAttachments": {
        "default": "Show more attachements",
        "value": "Show more attachements"
      },
      "showLessAttachments": {
        "default": "Close",
        "value": "Close"
      },
      "availableDates": {
        "default": "Available dates",
        "value": "Available dates"
      },
      "availableDatesDescription": {
        "default": "If necessary, change booking dates in the next step.",
        "value": "If necessary, change booking dates in the next step."
      },
      "weekView": {
        "default": "Week view",
        "value": "Week view"
      },
      "monthView": {
        "default": "Month view",
        "value": "To month view"
      },
      "yourChoice": {
        "default": "Your selection",
        "value": "Your selection"
      },
      "notAvailable": {
        "default": "Not available",
        "value": "Not available"
      },
      "pickupDrop": {
        "default": "Start and end",
        "value": "Start and end"
      },
      "offers": {
        "default": "Offers",
        "value": "Offers"
      },
      "consumables": {
        "default": "Consumables",
        "value": "Consumables"
      },
      "services": {
        "default": "Services",
        "value": "Services"
      },
      "accessories": {
        "default": "Extras",
        "value": "Extras"
      },
      "cancellationFees": {
        "default": "Cancellation fees",
        "value": "Cancellation fees"
      },
      "seasonDatetimes": {
        "default": "Saisonzeiten",
        "value": "Seasons"
      },
      "pickups": {
        "default": "Übernahme",
        "value": "Start"
      },
      "dropoffs": {
        "default": "Rückgabe",
        "value": "Dropoff"
      },
      "prolongation": {
        "default": "Rückgabe",
        "value": "Prolongation"
      },      
      "description": {
        "default": "Description",
        "value": "Description"
      },  
      "noOfferItems": {
        "default": "There are no offers.",
        "value": "There are no offers."
      },
      "showMoreOffers": {
        "default": "Show more offers",
        "value": "Show more offers"
      },
      "showLessOffers": {
        "default": "Close",
        "value": "Close"
      },
      "noConsumables": {
        "default": "There are no consumables.",
        "value": "There are no consumables."
      },
      "consumablesTabDescription": {
        "default": "Included consumables",
        "value": "Included consumables"
      },
      "showMoreConsumables": {
        "default": "Show more consumables",
        "value": "Show more consumables"
      },
      "showLessConsumables": {
        "default": "Close",
        "value": "Close"
      },
      "consumableMinimum": {
        "default": "At least",
        "value": "Minimum"
      },       
      "consumableFooterDescription": {
        "default": "pro zusätzliche(n)",
        "value": "for additional"
      },      
      "noServices": {
        "default": "There are no services.",
        "value": "There are no services"
      }, 
      "discount": {
        "default": "Discount",
        "value": "Discount"
      },
      "showMoreServices": {
        "default": "Show more services.",
        "value": "Show more services."
      },
      "showLessServices": {
        "default": "Close",
        "value": "Close"
      },
      "noAccessories": {
        "default": "There are no extras.",
        "value": "There are no extras."
      },
      "showMoreAccessories": {
        "default": "Show more extras",
        "value": "Show more extras"
      },
      "showLessAccessories": {
        "default": "Close",
        "value": "Close"
      },
      "noCancellationFees": {
        "default": "No cancellation fees.",
        "value": "No cancellation fees."
      },
      "daysToPickup": {
        "default": "Days until start",
        "value": "Days until start - or earlier"
      },
      "hoursToPickup": {
        "default": "Hours until start",
        "value": "Hours until start - or earlier"
      },      
      "percent": {
        "default": "Percent",
        "value": "Percent"
      },
      "fix": {
        "default": "Fix",
        "value": "Fix"
      },
      "showMoreCancellationFees": {
        "default": "Show more fees",
        "value": "Show more fees"
      },
      "showLessCancellationFees": {
        "default": "Close",
        "value": "Close"
      }
    },
    "home": {
      "location": {
        "default": "Location",
        "value": "Location"
      },
      "allLocationsSelected": {
        "default": "All locations",
        "value": "All"
      },
      "selectAllLocations": {
        "default": "All locations",
        "value": "All"
      },
      "noItemsLoadedYet": {
        "default": "No items loaded yet.",
        "value": "No items loaded yet."
      },
      "objectType": {
        "default": "Category",
        "value": "Category"
      },
      "allCategoriesSelected": {
        "default": "All",
        "value": "All"
      },
      "selectAllCategories": {
        "default": "All.",
        "value": "All"
      },
      "startDate": {
        "default": "Start date *",
        "value": "Start date *"
      },
      "noStartDateSelected": {
        "default": "No start date selected,",
        "value": "No start date selected."
      },
      "duration": {
        "default": "Duration *",
        "value": "Duration *"
      },
      "to": {
        "default": "to",
        "value": "to"
      },
      "count": {
        "default": "Number",
        "value": "Number"
      },
      "enterUnitsCount": {
        "default": "Enter units count",
        "value": "Enter units count"
      },
      "timeUnit": {
        "default": "Time unit",
        "value": "Time unit"
      },
      "enterUnitsType": {
        "default": "Enter units type",
        "value": "Enter units type"
      },
      "search": {
        "default": "Search",
        "value": "Search"
      },
      "priceFrom": {
        "default": "From",
        "value": "From"
      }
    },
    "userBookingDetail": {
      "cancelBookingMessage": {
        "default": "You are going to cancel this booking. Are you sure?",
        "value": "You are going to cancel this booking. Are you sure?"
      },      
      "enthalteneMwst": {
        "default": "Included VAT (${vatPercentage}%)",
        "value": "Included VAT (${vatPercentage}%)"
      },      
      "stornoGebuhren": {
        "default": "Storno-Gebühren",
        "value": "Cancellation fees"
      },
      "daysToPickup": {
        "default": "Tage bis zur Übernahme, oder früher",
        "value": "Days to start - or earlier"
      },
      "hoursToPickup": {
        "default": "Stunden bis zur Übernahme, oder früher",
        "value": "Hours to start - or earlier"
      },      
      "gesamtbetragFallig": {
        "default": "Gesamtbetrag, fällig",
        "value": "Total amount, due"
      },
      "anzahlungFallig": {
        "default": "Anzahlung, fällig",
        "value": "Downpayment, due"
      },      
      "back": {
        "default": "End",
        "value": "End"
      },
      "performPrint": {
        "default": "Print",
        "value": "Print"
      },
      "performCancel": {
        "default": "Cancel",
        "value": "Cancel"
      },
      "mietbetrag": {
        "default": "Price",
        "value": "Price"
      },
      "vatIncluded": {
        "default": "Incl. VAT",
        "value": "Incl. VAT"
      },      
      "bookedFrom": {
        "default": "Booking from",
        "value": "Booking from"
      },
      "bookedTo": {
        "default": "to",
        "value": "to"
      },
      "bookingNumber": {
        "default": "Booking-No.",
        "value": "Booking-No."
      },
      "bookingState": {
        "default": "Status",
        "value": "Status"
      },
      "bookingSaldo": {
        "default": "Balance",
        "value": "Balance"
      },
      "objectAndAccessories": {
        "default": "Object and extras",
        "value": "Object and extras"
      },
      "description": {
        "default": "Description",
        "value": "Description"
      },
      "count": {
        "default": "Qty.",
        "value": "Qty."
      },
      "offer": {
        "default": "Offer",
        "value": "Offer"
      },
      "season": {
        "default": "Season",
        "value": "Season"
      },
      "deposit": {
        "default": "Kaution",
        "value": "Deposit"
      },        
      "price": {
        "default": "Price",
        "value": "Price"
      },
      "subTotal": {
        "default": "Subtotal",
        "value": "Subtotal"
      },
      "conditionalServices": {
        "default": "Conditional fees",
        "value": "Conditional fees"
      },
      "article": {
        "default": "Article",
        "value": "Article"
      },
      "subtotal": {
        "default": "Subtotal",
        "value": "Subtotal"
      },
      "services": {
        "default": "Services",
        "value": "Services"
      },
      "discount": {
        "default": "Discount",
        "value": "Discount"
      },
      "totalDiscount": {
        "default": "Total Discount",
        "value": "Total Discount"
      },      
      "consumables": {
        "default": "Consumables",
        "value": "Consumables"
      },
      "consumableName": {
        "default": "Description",
        "value": "Description"
      },
      "unit": {
        "default": "Unit",
        "value": "Unit"
      },
      "minIncl": {
        "default": "Min. / Incl.",
        "value": "Min. / Incl."
      },
      "pricePerUnit": {
        "default": "Price / Unit",
        "value": "Price / Unit"
      },
      "extras": {
        "default": "Extras",
        "value": "Extras"
      },
      "priceShiftName": {
        "default": "Charge / Discount",
        "value": "Charge / Discount"
      },
      "percent": {
        "default": "Percent",
        "value": "Percent"
      },
      "fix": {
        "default": "Fix",
        "value": "Fix"
      },
      "bookingTotalPrice": {
        "default": "Grand total",
        "value": "Grand total"
      },
      "billingAmount": {
        "default": "Invoice amount",
        "value": "Invoice amount"
      },
      "receivedPayments": {
        "default": "Received payments",
        "value": "Received payments"
      }
    },
    "userBookings": {
      "archivedBookings": {
        "default": "Past bookings",
        "value": "Past bookings"
      },
      "activeBookings": {
        "default": "Active bookings",
        "value": "Active bookings"
      },
      "myBookings": {
        "default": "My bookings",
        "value": "My bookings"
      },
      "noBookingsYet": {
        "default": "No bookings yet.",
        "value": "No bookings yet"
      },
      "number": {
        "default": "Number",
        "value": "Number"
      },
      "object": {
        "default": "Object",
        "value": "Object"
      },
      "start": {
        "default": "Start",
        "value": "Start"
      },
      "end": {
        "default": "End",
        "value": "End"
      },
      "price": {
        "default": "Price",
        "value": "Price"
      },
      "state": {
        "default": "Status",
        "value": "Status"
      },
      "loadMore": {
        "default": "Load more",
        "value": "Load more"
      }
    },
    "search": {
      "location": {
        "default": "Location",
        "value": "Location"
      },
      "allLocations": {
        "default": "All",
        "value": "All"
      },
      "chooseAllLocations": {
        "default": "All",
        "value": "All"
      },
      "noItemsLoadedYet": {
        "default": "No items loaded yet.",
        "value": "No  items loaded yet"
      },
      "objectType": {
        "default": "Category",
        "value": "Category"
      },
      "allCategories": {
        "default": "All",
        "value": "All"
      },
      "chooseAllCategories": {
        "default": "All",
        "value": "All"
      },
      "startDate": {
        "default": "Start date",
        "value": "Start date"
      },
      "noStartDateSelected": {
        "default": "No start date selected",
        "value": "No start date selected"
      },
      "diration": {
        "default": "Duration",
        "value": "Duration"
      },
      "to": {
        "default": "to",
        "value": "to"
      },
      "count": {
        "default": "Qty.",
        "value": "Qty."
      },
      "enterUnitsCount": {
        "default": "Enter units count",
        "value": "Enter units count"
      },
      "timeUnit": {
        "default": "Time unit",
        "value": "Time unit"
      },
      "enterUnitsType": {
        "default": "Enter units type",
        "value": "Enter units type"
      },
      "properties": {
        "default": "Features",
        "value": "Features"
      },
      "doNotCare": {
        "default": "Don't care",
        "value": "Don't care"
      },
      "thereAreNoResults": {
        "default": "There were no results for your search.",
        "value": "There were no results for your search."
      },
      "fromPrice": {
        "default": "Starting at",
        "value": "Starting at"
      },
      "loadMore": {
        "default": "Load more",
        "value": "Load more"
      },
      "resetParameters": {
        "default": "Reset All",
        "value": "Reset All"
      },
      "showAll": {
        "default": "Show All",
        "value": "Show All"
      }             
    },
    "userProfile": {
      "street": {
        "default": "Street, Nr. *",
        "value": "Street, Nr. *"
      },        
      "addressAddition": {
        "default": "Address suffix",
        "value": "Address suffix"
      },
      "postNumber": {
        "default": "ZIP *",
        "value": "ZIP *"
      },
      "place": {
        "default": "Place *",
        "value": "Place *"
      },
      "country": {
        "default": "Country *",
        "value": "Country *"
      },
      "registrationTitle": {
        "default": "Sign up",
        "value": "Sign up"
      },
      "profileTitle": {
        "default": "Hello",
        "value": "Hello ${firstName}"
      },       
      "registrationSubtitle": {
        "default": "Sign up for wy.by.",
        "value": "Sign up for wy.by"
      },
      "profileSubtitle": {
        "default": "Edit your user profile.",
        "value": "Edit your user profile."
      },
      "customerInformation": {
        "default": "Customer information",
        "value": "Customer information"
      },        
      "salutation": {
        "default": "Salutation *",
        "value": "Salutation *"
      },
      "firstName": {
        "default": "First name *",
        "value": "First name *"
      },
      "lastName": {
        "default": "Family name *",
        "value": "Family name *"
      },
      "organization": {
        "default": "Organization",
        "value": "Organization"
      },         
      "email": {
        "default": "Email *",
        "value": "Email *"
      },
      "phone": {
        "default": "Phone",
        "value": "Phone"
      },
      "mobilePhone": {
        "default": "Cellphone *",
        "value": "Mobile *"
      },
      "timeZone": {
        "default": "Timezone",
        "value": "Timezone"
      },
      "language": {
        "default": "Corresponce language",
        "value": "Correspondence language"
      },
      "postalAddress": {
        "default": "Postal Address",
        "value": "Postal Address"
      },
      "billingAddress": {
        "default": "Billing Address",
        "value": "Billing Address"
      }, 
      "useDifferentBillingAddress": {
        "default": "Different billing address",
        "value": "Different billing address"
      },
      "password": {
        "default": "Password",
        "value": "Password"
      },
      "userNameReadOnly": {
        "default": "Username",
        "value": "Username"
      },
      "userNameEditable": {
        "default": "Username *",
        "value": "Username"
      },
      "oldPassword": {
        "default": "Old password",
        "value": "Old password"
      },
      "newPassword1": {
        "default": "New password *",
        "value": "New password *"
      },
      "newPassword2": {
        "default": "Confirm password *",
        "value": "Confirm password *"
      },
      "acceptAgb": {
        "default": "I accept the ",
        "value": "I accept the "
      },
      "agb": {
        "default": "General terms & conditions",
        "value": "General terms & conditions"
      },
      "back": {
        "default": "Cancel",
        "value": "Cancel"
      },
      "registrationSave": {
        "default": "Save",
        "value": "Save"
      },
      "profileSave": {
        "default": "Save",
        "value": "Save"
      },
      "registrationStep2Title": {
        "default": "Registration",
        "value": "Registration"
      },
      "registrationStep2Subtitle": {
        "default": "Thank you very much for your registration.",
        "value": "Thank you very much for your registration."
      },
      "registrationStep2Text": {
        "default": "Please follow a link in your email to activate the account.",
        "value": "Please follow a link in your email to activate the account."
      },
      "registrationStep2GoHome": {
        "default": "Go to homepage",
        "value": "Go to homepage"
      },
      "registrationStep4Title": {
        "default": "Registration",
        "value": "Registration"
      },
      "registrationStep4Subtitle": {
        "default": "You have registered successfully.",
        "value": "You have registered successfully."
      },
      "registrationStep4GoHome": {
        "default": "Go to homepage",
        "value": "Go to homepage"
      }
    },
    "authentication": {
      "loggedOutDueToInactivity": {
        "default": "You were logged out because of inactivity.",
        "value": "You were logged out because of inactivity.",
      }
    },
    "forgottenPassword": {
      "resetPassword": {
        "default": "Reset password",
        "value": "Reset password",
      },
      "enterEmailAddress": {
        "default": "Please enter the e-mail addresses you used for registration.",
        "value": "Please enter the e-mail addresses you used for registration.",
      }, 
      "yourEmailAddress": {
        "default": "Your e-mail address",
        "value": "Your e-mail address",
      }, 
      "cancel": {
        "default": "Cancel",
        "value": "Cancel",
      },   
      "sendEmail": {
        "default": "Send e-mail",
        "value": "Send e-mail",
      }, 
      "forgotPasswordEmail": {
        "default": "Forgotten password e-mail",
        "value": "Forgotten password e-mail",
      }, 
      "weHaveSentEmail": {
        "default": "We have sent an email with a password recovery link to ${email}. Please open the email and click on the password recovery link.",
        "value": "We have sent an email with a password recovery link to ${email}. Please open the email and click on the password recovery link.",
      },  
      "Home": {
        "default": "Homepage",
        "value": "Homepage",
      },
      "enterNewPassword": {
        "default": "Enter your new password and confirm it.",
        "value": "Enter your new password and confirm it.",
      },   
      "username": {
        "default": "Username",
        "value": "Username",
      }, 
      "newPassword": {
        "default": "New password",
        "value": "New password",
      },  
      "repeatNewPassword": {
        "default": "Repeat new password",
        "value": "Repeat new password",
      },  
      "passwordComplexityDesc": {
        "default": "The password must be minimum 7 characters with at least one lowercase character and one special character.",
        "value": "The password must be minimum 7 characters with at least one lowercase character and one special character.",
      },
      "save": {
        "default": "Save",
        "value": "Save",
      }, 
      "resetSuccessTitle": {
        "default": "Password successfully reset",
        "value": "Password successfully reset",
      },   
      "resetSuccessDesc": {
        "default": "Your password was successfully reset. Please go to the start page and log in.",
        "value": "Your password was successfully reset. Please go to the start page and log in.",
      },                                                                           
    }
  },
  "unbound": {}
}


// WEBPACK FOOTER //
// ./src/translate/resources/enUS.js